'use strict';

var HorizontalScrollSnap = require('../components/HorizontalScrollSnap.js');

var IS_ACTIVE_CLASS_NAME = 'isActive';
var IS_IN_VIEW_CLASS_NAME = 'isInView';

/**
 * @class
 */
var BookletSection = function(sectionElement) {
	this._sectionElement = sectionElement;
	
	this._onActiveChange = this._onActiveChange.bind(this);
	this._onInViewChange = this._onInViewChange.bind(this);
	this._onClickOfBulletControl = this._onClickOfBulletControl.bind(this);
	
	// Create horizontal scroll with snapping
	this._horizontalScrollSnap = new HorizontalScrollSnap({
		elements : {
			listenForEvents : sectionElement.querySelector('.bookletSection__scroll'),
			move : sectionElement.querySelector('.bookletSection__itemContainer'),
			viewport : sectionElement.querySelector('.bookletSection__viewPort'),
			contentSize : sectionElement.querySelector('.bookletSection__itemContainer')
		},
		snap : {
			elements : sectionElement.querySelectorAll('.booklet__item')
		},
		listeners : {
			activeChange : this._onActiveChange,
			inViewChange : this._onInViewChange
		}
	});
	this._horizontalScrollSnap.start();
	
	// Setup bullet controls
	this._bulletControlElements = sectionElement.querySelectorAll('.bulletControl');
	for (var x=0; x < this._bulletControlElements.length; x++) {
		this._bulletControlElements[x].addEventListener('click', this._onClickOfBulletControl, false);
	}
}

BookletSection.COMPONENT_STYLE_CLASS = 'bookletSection';

/**
 * @private
 */
BookletSection.prototype._onActiveChange = function(event, data) {
	var active = data.active;
	if (active !== null) {
		active.element.classList.add(IS_ACTIVE_CLASS_NAME);
	}
}

/**
 * @private
 */
BookletSection.prototype._onInViewChange = function (event, data) {
	var inViewChangeData, i, bulletElement;
	
	for (i=0; i < data.length; i++) {
		inViewChangeData = data[i];
		bulletElement = this._bulletControlElements[inViewChangeData.index];
		
		// Adjust the bullets
		if (inViewChangeData.cover > 0) {
			if (bulletElement !== undefined) {
				bulletElement.classList.add(IS_IN_VIEW_CLASS_NAME);
				
				var bulletFill = bulletElement.children[0].children[0];
				
				// The left and right are swapped on purpose on the next two lines.
				bulletFill.style.right = Math.round(inViewChangeData.left * 100) + '%';
				bulletFill.style.left = Math.round(inViewChangeData.right * 100) + '%';
			}
		} else {
			if (bulletElement !== undefined) {
				bulletElement.classList.remove(IS_IN_VIEW_CLASS_NAME);
			}
		}
		
		// Adjust styles on slides
		if (inViewChangeData.cover >= 0.90) {
			inViewChangeData.element.classList.add(IS_IN_VIEW_CLASS_NAME);
		} else {
			inViewChangeData.element.classList.remove(IS_IN_VIEW_CLASS_NAME);
			inViewChangeData.element.classList.remove(IS_ACTIVE_CLASS_NAME);
		}
	}
}

/**
 * @private
 */
BookletSection.prototype._onClickOfBulletControl = function(event) {
	event.preventDefault();
	var bulletElem = event.currentTarget;
	this._horizontalScrollSnap.animateTo(bulletElem.dataset.index);
}

module.exports = BookletSection;

